<script lang="ts">
import { defineComponent } from 'vue'

/**
 * StagingEnv
 */
const GLP_APP_ENV = import.meta.env.GLP_APP_ENV as string
export default defineComponent({
  data() {
    return {
      GLP_APP_ENV,
    }
  },
})
</script>

<template>
  <AppModal
    v-if="GLP_APP_ENV === 'staging'"
    id="staging-env"
    :close-on-blur="false"
    :open="true"
  >
    <div class="flex flex-col p-4 gap-2">
      <h1
        class="text-center mb-4 bg-red-400 mt-1 font-black text-2xl rounded-md"
      >
        Test Environment
      </h1>

      <p class="font-bold">
        You are currently in a testing environment. Some features may be limited
        or simulated.
      </p>

      <ul class="list-disc list-inside">
        <li>
          Game results may not be accurate or final and results won't be paid
          out.
        </li>
        <li>Payment processing is simulated; no real transactions occur.</li>
        <li>Data may be reset periodically for testing purposes.</li>
      </ul>
    </div>
  </AppModal>
</template>

<style lang="scss">
#staging-env::backdrop {
  @apply bg-red-500/50 !important;
}
</style>
